import API from 'services/API';

export default function uploadAvatar(data) {
  return API.request({
    method: 'POST',
    url: '/profile/uploadPhoto',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
